
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./web-analytics.cjs.production.min.js')
} else {
  module.exports = require('./web-analytics.cjs.development.js')
}
